module.exports = __webpack_public_path__ + "static/media/aahar.11f0ad24.jpg";